module.exports = __webpack_public_path__ + "assets/list-layout-active.ac7b1aac.svg";